// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__Lh","cls2":"NewsInteractionBar-cls2_qs2 NewsInteractionBar-cls1__Lh","variant-dense":"NewsInteractionBar-variant-dense_Fxu"};